import { html } from 'lit-html';
import { AddRecommendationItemJsEnv } from '../models/add_recommendation_item_js_env';
import { getAssetsUrlBase } from '../../../core/models/common/static_resource_util';

export const Warning = (model: AddRecommendationItemJsEnv) => html`
${ model.isWarningHidden ? hidden() : visible(model.warningMessage) }
`;

export const CreateFolderWarningCreateFolder = (model: AddRecommendationItemJsEnv) => html`
${ model.isCreateFolderWarningHidden ? hidden() : visible(model.warningMessage) }
`;

export const visible = (warningMessage: string) => html`
<div class="a-box -warning u-mb-16">
  <div class="m-information -warning">
    <p class="m-information_hdg">
      <span class="m-information_hdgicon">
        <span class="a-icon -size24"><img class="a-icon_img" src="${getAssetsUrlBase()}images/icon_information_red.svg" alt="" width="24" height="24"></span>
      </span>
      <span class="m-information_hdgmain">
        <span class="m-information_hdgmain_text">${warningMessage}</span>
      </span>
    </p>
  </div>
</div>
`;

export const hidden = () => html``;
